import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClientModule } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatRippleModule } from '@angular/material/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { NgxMaskModule } from 'ngx-mask';
import { NgxStripeModule } from 'ngx-stripe';
import { NgDatePipesModule } from 'ngx-pipes';
import { NgStringPipesModule } from 'ngx-pipes';

import { GoogleMapComponent } from './map/google-map.component';
import { StripeBillingComponent } from './stripe-billing/stripe-billing.component';
import { PaymentMethodComponent } from './payment-method/payment-method.component';
import { LoginTimeoutComponent } from '../authentication/login-timeout/login-timeout.component';
import { BackgroundWrapperComponent } from './background-wrapper/background-wrapper.component';
import { TonicCardThemeWrapperComponent } from './tonic-card-theme-wrapper/tonic-card-theme-wrapper.component';

@NgModule({
  declarations: [
    GoogleMapComponent,
    StripeBillingComponent,
    PaymentMethodComponent,
    LoginTimeoutComponent,
    BackgroundWrapperComponent,
    TonicCardThemeWrapperComponent
  ],
  imports: [
    CommonModule,

    NgDatePipesModule,
    NgStringPipesModule,
    DragDropModule,
    GoogleMapsModule,
    ReactiveFormsModule,

    ScrollingModule,

    MatIconModule,
    MatCardModule,
    MatTabsModule,
    MatListModule,
    MatMenuModule,
    MatSortModule,
    MatInputModule,
    MatTableModule,
    MatChipsModule,
    MatRadioModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatSliderModule,
    MatRippleModule,
    MatDividerModule,
    MatSidenavModule,
    MatToolbarModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    NgxMaskModule.forRoot(),

    NgxStripeModule.forRoot('pk_test_wAjzTIQhMzMoHbNQjoej9pDs'),

  ],
  exports: [
    CommonModule,

    NgDatePipesModule,
    NgStringPipesModule,
    DragDropModule,
    GoogleMapsModule,
    ReactiveFormsModule,

    ScrollingModule,

    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDividerModule,
    HttpClientModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatSnackBarModule,
    ReactiveFormsModule,

    MatIconModule,
    MatCardModule,
    MatTabsModule,
    MatListModule,
    MatMenuModule,
    MatSortModule,
    MatInputModule,
    MatTableModule,
    MatChipsModule,
    MatRadioModule,
    MatButtonModule,
    MatSelectModule,
    MatSliderModule,
    MatRippleModule,
    MatDividerModule,
    MatSidenavModule,
    MatToolbarModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatProgressSpinnerModule,

    GoogleMapComponent,
    StripeBillingComponent,
    PaymentMethodComponent,
    BackgroundWrapperComponent,
    TonicCardThemeWrapperComponent
  ]
})
export class PortalModule { }
